import React, { useEffect } from "react";
import Layout from "../../layout/builders/Layout";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import PortfolioUpload from "../../layout/builders/ProjectPortfolio/PortfolioTile";
import PortfolioDisplay from "../../layout/builders/ProjectPortfolio/PortfolioDisplay";
import usePortfolioStore from "../../store/builders/usePortfolioStore";

const Portfolio = () => {
    const { portfolio, isUploading, isDeleting, fetchPortfolio } = usePortfolioStore();

    useEffect(() => {
        // Fetch existing portfolio items when the component mounts
        fetchPortfolio();
    }, [fetchPortfolio]);

    return (
        <div className="min-h-screen bg-gray-100">
            <Layout>
                <div>
                    <ProjectBanner
                        title="My Portfolio"
                        imageUrl="https://via.placeholder.com/1200x300"
                    />
                </div>
                <div className="space-y-2">
                    {/* Section for uploading new images */}
                    <PortfolioUpload />

                    {/* Section divider */}
                    <div className="relative my-2">
                        <div className="absolute inset-0 flex items-center" aria-hidden="true">
                            <div className="w-full border-t border-gray-300 border-dashed" />
                        </div>
                        <div className="relative flex justify-center">
                            <span className="bg-gray-200 px-3 text-sm font-medium text-gray-600 rounded-full">Your Gallery</span>
                        </div>
                    </div>

                    {/* Section for displaying existing portfolio items */}
                    <div>
                        <PortfolioDisplay portfolios={portfolio} isLoading={isUploading || isDeleting} />
                    </div>
                </div>
            </Layout>
        </div>
    );
};

export default Portfolio;